export default __webpack_public_path__ + "static/media/stars.2653ad05.svg";